const attributes = {
  toast: {
    error: {
      badResponse: '[Attribute] update error',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {
        default: '[Attribute] has been updated successfully',
      },
      delete: {
        body: 'Attributes were deleted successfully',
      },
    },
  },
  table: {
    headerButtons: {
      create: 'Create',
      delete: {
        label: 'Delete',
        deleteModal: {
          header: 'Delete Attributes',
          body: 'You are about to delete {{attributes}} attributes',
        },
      },
      clear: {
        label: 'Clear',
        clearModal: {
          header: 'Clear Attributes',
          body: 'You are about to clear {{attributes}} attributes',
        },
      },
      import: 'Import',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    placeholder: {
      select: 'Select',
    },
    headers: {
      name: 'Name',
      labels: 'Labels',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  form: {
    header: {
      createAttribute: {
        title: 'Create',
      },

      updateAttribute: {
        title: 'Update',
      },
    },
    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
      resetButton: 'Reset Advanced Settings',
    },
    information: {
      details: {
        header: 'General Information',
        fields: {
          name: 'Name',
          description: 'Description',
        },
      },
      aliases: {
        header: 'Attribute Name Mapping',
        fields: {
          drivers: 'Drivers',
          vehicles: 'Vehicles',
          bookings: 'Bookings',
        },
      },
      advanced: {
        header: 'Advanced Settings',
        fields: {
          sharedRideRatio: 'Max Shared Time Ratio',
          maxSharedDistanceRatio: {
            label: 'Max Shared Distance Ratio',
            description:
              'Defines how much longer a shared ride is allowed to be compared to the solo distance. Example: If solo distance is 1 mile and the ratio is 1.2x, the shared ride for that passenger cannot exceed 1.2 miles',
          },
          maxSinglePassengerTime: 'Max Single Passenger Trip Time',
          maxPassengers: 'Max Passengers',
          maxTripStops: 'Max Stops',
          tripBoardingTime: 'Boarding Time',
          tripBoardingTimeForSubsequentPassengers: 'Secondary Boarding Time',
          tripDropOffTime: 'Drop-off Time',
          tripDropOffTimeForSubsequentPassengers: 'Secondary Drop-off Time',
          attributeReassignment: 'Enable Attribute Re-Routing',
          attributeReassignmentDescription:
            'When enabled, this setting triggers automatic re-routing of trips in response to updates in specific booking attributes. Without enabling this setting, attribute changes will not prompt trip re-routing.',
          matchScore: 'Enable Driver/Vehicle-Booking Attribute Matching',
          matchScoreDescription:
            'Enabling this setting allows the system to consider attribute matching when assigning drivers/vehicles to bookings. Without enabling this setting, the system will disregard that attribute when making drivers/vehicles-bookings matches.',
          maxBoardingDelay: 'Max Boarding Delay',
          maxBoardingEarly: 'Max Boarding Early',
          maxDropOffEarly: {
            label: 'Max Drop-off Early',
            description: 'Maximum number of minutes a driver can get early relative to the drop-off time set in the reservation',
          },
          maxDropOffDelay: {
            label: 'Max Drop-off Delay',
            description: 'Maximum number of minutes a driver can be late for the drop off time set in the reservation Number',
          },
          minScore: 'Min Score',
          waitAndReturn: 'Wait and Return',
          waitAndReturnDescription:
            'The duration in minutes that a driver will wait between the outbound and return legs of a wait-and-return trip.',
          off: 'Off',
          maxPassengerAtOnce: 'Max Passenger At Once',
          maxPickupStops: 'Max Pickup Stops',
          maxDropoffStops: 'Max Dropoff Stops',
          groupWaitAndReturn: 'Group Wait and Return',
          groupWaitAndReturnOptions: {
            off: 'Off',
            individualPair: 'Individual Pair Grouping',
            multiplePairs: 'Multiple Pair Grouping',
          },
          onlyPrivate: 'Only Private',
          maxSimultaneousBookings: 'Max Simultaneous Bookings',
          sharedWith: 'Shared With',
          willCallTimeOffset: 'Will Call Time Offset',
          leg: {
            label: 'Enable as Leg',
            description: 'This Leg is already assigned to another attribute.',
          },
        },
        modal: {
          title: 'Wait And Return',
          body: {
            enableWaitAndReturn:
              "You are about to enable the 'Wait and Return' setting. This will apply to all current and future bookings that qualify as 'Wait & Return.' Are you sure you want to proceed?",
            disableWaitAndReturn:
              "You are about to disable the 'Wait and Return' setting. This will remove it from all current and future bookings identified as 'Wait & Return.' Are you sure you want to proceed?",
          },
        },
      },
    },
    valdations: {
      name: {
        required: 'Name is required',
        name: 'Invalid Name',
      },
      unit: {
        required: 'Unit is required',
        name: 'Invalid Unit',
      },
      parameters: {
        required: 'Paraemters are required',
        name: 'Check carefully the values you are passing',
      },
    },
    create: {
      toastError: {
        message: 'Could Not Create',
      },
      toastSuccess: {
        message: 'Created successfully',
      },
    },
    update: {
      formTabs: {
        generalInfo: 'General',
        advanced: 'Advanced Settings',
        history: 'History',
      },
      toastError: {
        message: 'Could Not Update',
      },
      toastSuccess: {
        message: 'Updated successfully',
      },
    },
  },
  import: {
    title: 'Attributes Upload',
  },
};

export default attributes;
